export var PRZELEWY24_TERMS_LINK = 'https://pragmago.pl/marketing/regulamin/regulamin-przelewy24-finance.pdf';
export var PRAGMA_TERMS_LINK = 'https://pragmago.pl/marketing/regulamin/regulamin_pragmago_online.pdf';
export var LIBERIS_PRIVACY_POLICY_LINK = 'https://www.liberis.com/privacy-policy';
export var LIBERIS_LINK = 'https://www.liberis.com/';
export var P24_DISPOSITIONS_EMAIL = 'dyspozycje@przelewy24.pl';
export var P24_DISPOSITIONS_PHONE = '+48 61 642 90 80';
